import { Avatar, Badge, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import Moment from 'react-moment';
import ALinkNested from '../../utils/ALinkNested';
import { DivCard, DivHorizental, DivVertical } from '../LandingPage/LandingPage';
import { useDispatch } from 'react-redux';
import { getChatMessages } from '../../../_actions/user_actions';

function ChatListPage(props) {

    const user = props.user?.userData;
    const [ChatList, setChatList] = useState([]);
    const [BlankMessage, setBlankMessage] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        getMyChatList();
    }, []);

    const getMyChatList = (variables) => {
        dispatch(getChatMessages(variables)).then(response => {
            if (response.payload.success) {
                let totalChatList = response.payload.chatRooms;
                setChatList(totalChatList);

                if (!totalChatList?.length) setBlankMessage('참여 중인 채팅 방이 없습니다. 원하는 상대방의 프로필을 눌러 메세지를 보내보세요.')
            }
        });
    };

    const renderChatList = (arrChatRooms) => arrChatRooms.map((chatRoom, i) => {
        const secondMember = chatRoom.members?.filter(m => m._id !== user?._id)?.[0] || user;
        const lastChat = chatRoom.messages?.[chatRoom.messages.length - 1];
        const chatRoomTitle = chatRoom.title || chatRoom.members?.map(m => m.name + ",");
        const visitedAt = chatRoom.memberVisitedMap?.[user?._id] || 0;
        const newChatCount = chatRoom.messages?.filter(msg => {
            return new Date(msg.createdAt) > new Date(visitedAt);
        })?.length;

        return <DivCard key={chatRoom._id}><DivHorizental>
            <ALinkNested pathname='/profile' state={{ targetUser: secondMember }} style={{ width: 'auto', margin: '1px' }}>
                <DivVertical>
                    <Avatar style={{ margin: 'auto' }} src={secondMember?.image} />
                </DivVertical>
            </ALinkNested>
            <ALinkNested pathname={`/chat_detail`} state={{ chatRoom, secondMember, title: chatRoom.title }} style={{ width: '100%', overflow: 'hidden' }}>
                <DivVertical >
                    <DivHorizental>
                        <label style={{ flex: 1, fontWeight: 'bold' }}>{chatRoomTitle}</label>
                        <Moment style={{ textAlign: 'right' }} fromNow>{lastChat?.createdAt || chatRoom?.createdAt}</Moment>
                    </DivHorizental>
                    <Badge count={newChatCount} offset={[-10, 7]}>
                        <label style={{ height: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {lastChat?.message || '(메세지 없음)'}
                        </label>
                    </Badge>
                </DivVertical>
            </ALinkNested>
        </DivHorizental></DivCard>
    });

    return (
        <div className='page'>
            {ChatList?.length ?
                renderChatList(ChatList)
                :
                <h3>{BlankMessage || <Spin />}</h3>
            }
        </div>
    );
}

export default ChatListPage;